import { activityService } from '_services';
import { session } from '_helpers';
import { ACTIONS_ACTIVITY } from '_constants/activity.constants';
import alertActions from './alert.actions';

export const receiveActivities = (activities) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < activities.length; i++) {
    byIdObjectToDispatch[activities[i].activityID] = activities[i];
  }

  return {
    type: ACTIONS_ACTIVITY.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteActivity = (activityID) => ({
  type: ACTIONS_ACTIVITY.DELETE,
  byId: { [activityID]: null }
});

export const invalidateActivities = () => ({
  type: ACTIONS_ACTIVITY.INVALIDATE
});

const getActivities = (accountID) => async (dispatch) => {
  try {
    const resp = await activityService.getAll(accountID);
    if (resp?.[0]?.activityID) {
      dispatch(receiveActivities(resp));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error retrieving activities.'));
  }
  return null;
};

const getActivity = (activityID) => async (dispatch) => {
  try {
    const resp = await activityService.getById(activityID);
    if (resp?.activityID) {
      dispatch(receiveActivities([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error retrieving activitiy #${activityID}.`));
  }
  return null;
};

const addActivity = (activity) => async (dispatch) => {
  try {
    const resp = await activityService.create(activity);
    if (resp?.activityID && !resp.parentActivityID) { // Note - parentActivityID check will be removed once activities have been flattened out.
      dispatch(receiveActivities([ resp ]));
    }
    return resp;
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const updActivity = (activity) => async (dispatch) => {
  try {
    const resp = await activityService.update(activity);
    if (resp?.activityID) {
      dispatch(receiveActivities([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const delActivity = (activityID) => async (dispatch) => {
  try {
    const resp = await activityService.delete(activityID);
    if (resp?.activityID) {
      dispatch(deleteActivity(resp.activityID));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error removing activity #${activityID}.`));
  }
  return null;
};

const invalidate = () => async (dispatch) => {
  dispatch(invalidateActivities());
};

const activityActions = {
  getActivities,
  getActivity,
  addActivity,
  updActivity,
  delActivity,
  invalidate
};

export default activityActions;
